export const wrapperInventoryControl = {
	titleWrapper: "Crear nuevo inventario",
	titleButtons: {
		sendInventory: "Enviar inventario",
		approveInventory: "Aprobar inventario",
		retellInventory: "Recontar",
		downloadInExcel: "Descargar en excel",
	},
	reopenModal: {
		title: "Recontar inventario",
		body:
			"Al recontar, el inventario vuelve al almacenista con la justificación informada.",
		reasonLabel: "Justificación",
		reasonPlaceholder: "Escribe el motivo del reconteo",
		reasonRequired: "Informa la justificación",
		reasonMaxLength: "La justificación debe tener como máximo {{maxLength}} caracteres",
		confirm: "Recontar",
		cancel: "Cancelar",
	},
	placeholders: {
		keywordSearch: "Buscar por categoría, código o producto",
	},
	headerInfos: {
		name: "Nombre",
		inventoryTitle: "Título del inventario",
		createAt: "Fecha de creación",
		lastEdtion: "Última edición",
		detailsInventory: "Detalles del inventario",
		stockist: "Almacenista",
		totalProducts: "Total de productos",
		categoriesSelected: "Categorías seleccionadas",
		storageSelected: "Inventario seleccionado",
		storageAndCategoriesSelected: "Inventario y categorías",
		status: "Estado",
	},
	seeMoreDetails: "Ver más detalles",
	drawerInfos: {
		seeDetails: "Ver detalles",
	},
};
